module.exports = __webpack_public_path__ + "img/backpack-no-need-table-icon.37bf8800.svg";